import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />

        <div className="cart-page__empty">
          <div className="cart-page__empty-box">
            <h2>Your cart is empty</h2>
            <p>Explore our collection of fine teas and ceramics!</p>
            <Link
              to="/shop"
              onClick={toTop}
              className="cart-page__continue-btn"
            >
              Continue shopping
            </Link>
          </div>
        </div>

        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <main className="cart-sheet">
        <div className="cart-sheet__header">
          <div className="title">Cart</div>
        </div>

        <div className="cart-sheet__items">
          {cartItems.map((item) => {
            const product = getProductById(item.id);
            if (!product) return null;
            const displayPrice = Math.round(Number(product.price)).toLocaleString("en-US");
            const coverImage = product.images?.[0] || product.image;
            return (
              <div
                className="sheet-item"
                key={`${item.id}-${item.size}-${item.color}`}
              >
                <div className="thumb">
                  <img src={coverImage} alt={product.name} />
                </div>
                <div className="details">
                  <div className="name-line">
                    {product.name}
                    {product.material ? `, ${product.material}` : ""},{" "}
                    {item.color}
                  </div>
                  <div className="price">€{displayPrice}</div>
                  <div className="meta">
                    {item.size} / {String(item.color).toUpperCase()}
                  </div>
                  <div className="qty-row">
                    <button
                      className="qty-btn"
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity - 1
                        )
                      }
                      aria-label="Decrease quantity"
                    >
                      &minus;
                    </button>
                    <span className="qty-val">{item.quantity}</span>
                    <button
                      className="qty-btn"
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity + 1
                        )
                      }
                      aria-label="Increase quantity"
                    >
                      +
                    </button>
                    <button
                      className="remove-btn"
                      onClick={() =>
                        removeFromCart(item.id, item.size, item.color)
                      }
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="cart-sheet__footer">
          <div className="order-note">ADD ORDER NOTE</div>
          <div className="tax-info">
            Taxes and shipping calculated at checkout
          </div>

          <button className="checkout-btn" onClick={handleCheckout}>
            CHECKOUT
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
